<template>
	<div>
		<el-dialog title="添加" width="800px" class="icon-dialog" :visible.sync="show" @open="open" :before-close="closeForm"
			append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
				<el-row>
					<el-col :span="24">
						<el-form-item label="讲师名称" prop="lecturer_name">
							<el-input v-model="form.lecturer_name" autoComplete="off" clearable
								placeholder="请输入讲师名称"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-if="userinfo.Permissions_type == 1">
					<el-form-item label="所属代理">
						<el-select style="width: 160px;" size="small" v-model="form.trainer_user_id" placeholder="请选择">
							<el-option v-for="type in type" :label="type.trainer_name" :value="type.trainer_user_id"
								:key="type.value"></el-option>
						</el-select>
					</el-form-item>
				</el-row>

				<el-row>
					<el-col :span="24">
						<el-form-item label="讲师介绍" prop="introduce">
							<el-input v-model="form.introduce" type="textarea" clearable placeholder="请输入讲师介绍"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="手机号/账号" prop="phone">
							<el-input v-model="form.phone" autoComplete="off" clearable placeholder="请输入手机号/账号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="密码" prop="pass">
							<el-input v-model="form.pass" autoComplete="off" clearable placeholder="请输入密码"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="抖音号" prop="dy_number">
							<el-input v-model="form.dy_number" autoComplete="off" clearable placeholder="请输入抖音号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label="快手号" prop="ks_number">
							<el-input v-model="form.ks_number" autoComplete="off" clearable placeholder="请输入快手号"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getAddLecturer, getTrainerUserId } from '../../api/userMG';
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
	},
	data() {
		return {
			updatehttp:'/lecturer/putFile',
			headers: {
				token: localStorage.getItem('logintoken')
			},
			form: {
				lecturer_name: '',
				trainer_user_id: '',
				introduce: '',
				phone: '',
				pass: '',
				dy_number: '',
				ks_number: ''
			},
			editorOption: {
			},
			classify: [],
			role_ids: [],
			loading: false,
			lists: [],
			pcidlist: [],
			rules: {
			},
			userinfo: {},
			type: [],
			updata: {
				file_name: 0
			}

		}
	},
	created() {
		this.userinfo = JSON.parse(localStorage.getItem('userdata'))
		console.log(this.userinfo.Permissions_type);
	},
	methods: {
		handleAvatarSuccess(res, file) {
			console.log(res, '成功失败');
			this.form.face = res.img_url
		},
		beforeAvatarUpload(file) {
			// const isJPG = file.type === 'image/jpeg';
			// const isLt2M = file.size / 1024 / 1024 < 2;

			// if (!isJPG) {
			// this.$message.error('上传头像图片只能是 JPG 格式!');
			// }
			// if (!isLt2M) {
			// this.$message.error('上传头像图片大小不能超过 2MB!');
			// }
			// return isJPG && isLt2M;
		},
		open() {
			getTrainerUserId().then(res => {
				this.type = res.info
			})
		},
		submit() {
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getAddLecturer(this.form).then(res => {
						console.log(res.code);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
							this.form = {
								lecturer_name: '',
								trainer_user_id: '',
								introduce: '',
								phone: '',
								pass: '',
								dy_number: '',
								ks_number: ''
							}
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			this.form = {
				lecturer_name: '',
				trainer_user_id: '',
				face: '',
				introduce: '',
				phone: '',
				pass: '',
				dy_number: '',
				ks_number: ''
			}
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped >
.editor {
	height: 200px;
}

.flexs {
	display: flex;
	justify-content: space-between;
	width: 600px;
	margin-bottom: 10px;
}

.flexs-l {}

.videos {
	margin-top: 10px;
	width: 160px;
	height: 160px;
}

.avatar-uploader .el-upload {
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
	border: 1px solid #dadcdf;
	margin-top: 10px;
	border-radius: 10px;
}

.avatar {
	width: 100px;
	height: 100px;
	display: block;
	border: 1px solid #dadcdf;
}
</style>



// WEBPACK FOOTER //
// src/views/lecturer/add.vue